import { useEffect, useRef } from 'react';
import { useLocation } from "react-router";
import { trackPageView } from '@/lib/analyticsTracking';

export const useAnalyticsTracking = () => {
  const location = useLocation();
  const lastPathRef = useRef<string>('');

  useEffect(() => {
    // Only track if the path actually changed
    if (location.pathname !== lastPathRef.current) {
      lastPathRef.current = location.pathname;
      trackPageView(location.pathname);
    }
  }, [location.pathname]);
};
